var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAchive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2360_3068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 2.5V13.75C8.75 18.5825 12.6675 22.5 17.5 22.5C22.3325 22.5 26.25 18.5825 26.25 13.75V2.5H8.75Z",
    fill: "#FDDC5C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 0.9375C1.63705 0.9375 0.9375 1.63705 0.9375 2.5V10C0.9375 14.0629 4.03895 17.4015 8.0035 17.7773C9.29618 20.8216 12.01 23.1167 15.3125 23.83V30.3125H11.25C10.0419 30.3125 9.0625 31.292 9.0625 32.5C9.0625 33.708 10.0419 34.6875 11.25 34.6875H23.75C24.9581 34.6875 25.9375 33.708 25.9375 32.5C25.9375 31.292 24.9581 30.3125 23.75 30.3125H19.6875V23.83C22.99 23.1167 25.7038 20.8216 26.9965 17.7773C30.961 17.4015 34.0625 14.0629 34.0625 10V2.5C34.0625 1.63705 33.363 0.9375 32.5 0.9375H2.5ZM10.3125 4.0625V13.75C10.3125 17.7196 13.5304 20.9375 17.5 20.9375C21.4696 20.9375 24.6875 17.7196 24.6875 13.75V4.0625H10.3125ZM7.1875 4.0625H4.0625V10C4.0625 12.041 5.36687 13.7773 7.1875 14.4208V4.0625ZM27.8125 4.0625V14.4208C29.633 13.7773 30.9375 12.041 30.9375 10V4.0625H27.8125Z",
    fill: "#0C098C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2360_3068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchive);
export default __webpack_public_path__ + "static/media/Achive.09c675ff254b02aa897dcc553233731d.svg";
export { ForwardRef as ReactComponent };